import React from 'react';
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Label,
    Input,
    FormFeedback
} from 'reactstrap';
import PhoneInput from "../../../../../components/Forms/PhoneInput";
import { DISTRICTS } from "../../../../../constants/districts";

const ACCOUNT_TYPES = [
    { value: 'SOLE_PROPRIETORSHIP', label: 'Şahıs Şirketi' },
    { value: 'JOINT_STOCK_COMPANY', label: 'Anonim Şirket' },
    { value: 'LIMITED_COMPANY', label: 'Limited Şirket' },
    { value: 'COOPERATIVE', label: 'Kooperatif' },
    { value: 'GENERAL_PARTNERSHIP', label: 'Kollektif Şirket' }
];

// DISTRICTS objesinin key'lerinden şehir listesi
const TURKISH_CITIES = Object.keys(DISTRICTS);

const CustomerForm = ({
                          formik,
                          showOnlyEmail,
                          requiresCustomerInfo
                      }) => {
    const selectedProvince = formik.values.customer_province;
    const districtOptions = selectedProvince ? (DISTRICTS[selectedProvince] || []) : [];

    return (
        <Card className="mb-4">
            <CardHeader>
                <h5 className="mb-0">
                    <i className="bx bx-user me-2" />
                    Müşteri Bilgileri
                </h5>
            </CardHeader>
            <CardBody>
                {showOnlyEmail ? (
                    <FormGroup className="mb-3">
                        <Label>E-posta Adresi *</Label>
                        <Input
                            type="email"
                            placeholder="E-posta adresinizi giriniz"
                            value={formik.values.customer_email}
                            onChange={e => formik.setFieldValue('customer_email', e.target.value)}
                            invalid={formik.touched.customer_email && !!formik.errors.customer_email}
                        />
                        {formik.touched.customer_email && formik.errors.customer_email && (
                            <FormFeedback>{formik.errors.customer_email}</FormFeedback>
                        )}
                    </FormGroup>
                ) : (
                    <>
                        <Row>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label>Ad Soyad *</Label>
                                    <Input
                                        type="text"
                                        placeholder="Ad ve soyadınızı giriniz"
                                        value={formik.values.customer_name}
                                        onChange={e => formik.setFieldValue('customer_name', e.target.value)}
                                        invalid={formik.touched.customer_name && !!formik.errors.customer_name}
                                    />
                                    {formik.touched.customer_name && formik.errors.customer_name && (
                                        <FormFeedback>{formik.errors.customer_name}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <Label>E-posta Adresi *</Label>
                                    <Input
                                        type="email"
                                        placeholder="E-posta adresinizi giriniz"
                                        value={formik.values.customer_email}
                                        onChange={e => formik.setFieldValue('customer_email', e.target.value)}
                                        invalid={formik.touched.customer_email && !!formik.errors.customer_email}
                                    />
                                    {formik.touched.customer_email && formik.errors.customer_email && (
                                        <FormFeedback>{formik.errors.customer_email}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup className="mb-3">
                                    <PhoneInput
                                        label="Telefon Numarası *"
                                        name="customer_phone"
                                        value={formik.values.customer_phone}
                                        onChange={formik.handleChange}
                                        invalid={formik.touched.customer_phone && !!formik.errors.customer_phone}
                                    />
                                    {formik.touched.customer_phone && formik.errors.customer_phone && (
                                        <FormFeedback className="d-block">{formik.errors.customer_phone}</FormFeedback>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>

                        {requiresCustomerInfo && (
                            <>
                                <FormGroup className="mb-3">
                                    <Label>Cari/Bayi Tipi *</Label>
                                    <Input
                                        type="select"
                                        value={formik.values.accountType}
                                        onChange={e => {
                                            formik.setFieldValue('accountType', e.target.value);
                                            formik.setFieldValue('tcNumber', '');
                                            formik.setFieldValue('taxNumber', '');
                                        }}
                                        invalid={formik.touched.accountType && !!formik.errors.accountType}
                                    >
                                        <option value="">-- Cari/Bayi tipi seçiniz --</option>
                                        {ACCOUNT_TYPES.map(t => (
                                            <option key={t.value} value={t.value}>
                                                {t.label}
                                            </option>
                                        ))}
                                    </Input>
                                    {formik.touched.accountType && formik.errors.accountType && (
                                        <FormFeedback>{formik.errors.accountType}</FormFeedback>
                                    )}
                                </FormGroup>

                                <FormGroup className="mb-3">
                                    <Label>Şirket Adı *</Label>
                                    <Input
                                        type="text"
                                        placeholder="Şirket adını giriniz"
                                        value={formik.values.companyName}
                                        onChange={e => formik.setFieldValue('companyName', e.target.value)}
                                        invalid={formik.touched.companyName && !!formik.errors.companyName}
                                    />
                                    {formik.touched.companyName && formik.errors.companyName && (
                                        <FormFeedback>{formik.errors.companyName}</FormFeedback>
                                    )}
                                </FormGroup>

                                {formik.values.accountType === 'SOLE_PROPRIETORSHIP' ? (
                                    <FormGroup className="mb-3">
                                        <Label>T.C. Kimlik No *</Label>
                                        <Input
                                            type="text"
                                            placeholder="11 hane"
                                            maxLength={11}
                                            value={formik.values.tcNumber}
                                            onChange={e => formik.setFieldValue('tcNumber', e.target.value)}
                                            invalid={formik.touched.tcNumber && !!formik.errors.tcNumber}
                                        />
                                        {formik.touched.tcNumber && formik.errors.tcNumber && (
                                            <FormFeedback>{formik.errors.tcNumber}</FormFeedback>
                                        )}
                                    </FormGroup>
                                ) : formik.values.accountType ? (
                                    <FormGroup className="mb-3">
                                        <Label>Vergi No *</Label>
                                        <Input
                                            type="text"
                                            placeholder="10 hane"
                                            maxLength={10}
                                            value={formik.values.taxNumber}
                                            onChange={e => formik.setFieldValue('taxNumber', e.target.value)}
                                            invalid={formik.touched.taxNumber && !!formik.errors.taxNumber}
                                        />
                                        {formik.touched.taxNumber && formik.errors.taxNumber && (
                                            <FormFeedback>{formik.errors.taxNumber}</FormFeedback>
                                        )}
                                    </FormGroup>
                                ) : null}

                                <FormGroup className="mb-3">
                                    <Label>Vergi Dairesi *</Label>
                                    <Input
                                        type="text"
                                        placeholder="Vergi dairesi giriniz"
                                        value={formik.values.taxOffice}
                                        onChange={e => formik.setFieldValue('taxOffice', e.target.value)}
                                        invalid={formik.touched.taxOffice && !!formik.errors.taxOffice}
                                    />
                                    {formik.touched.taxOffice && formik.errors.taxOffice && (
                                        <FormFeedback>{formik.errors.taxOffice}</FormFeedback>
                                    )}
                                </FormGroup>

                                {/* Eski Telefon Alanı burada olduğu için kaldırıldı */}

                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label>Ülke</Label>
                                            <Input
                                                type="text"
                                                value={formik.values.customer_country}
                                                onChange={e => formik.setFieldValue('customer_country', e.target.value)}
                                                readOnly
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label>İl *</Label>
                                            <Input
                                                type="select"
                                                value={formik.values.customer_province}
                                                onChange={e => {
                                                    formik.setFieldValue('customer_province', e.target.value);
                                                    formik.setFieldValue('customer_district', '');
                                                }}
                                                invalid={formik.touched.customer_province && !!formik.errors.customer_province}
                                            >
                                                <option value="">İl seçiniz</option>
                                                {TURKISH_CITIES.map(city => (
                                                    <option key={city} value={city}>
                                                        {city}
                                                    </option>
                                                ))}
                                            </Input>
                                            {formik.touched.customer_province && formik.errors.customer_province && (
                                                <FormFeedback>{formik.errors.customer_province}</FormFeedback>
                                            )}
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup className="mb-3">
                                            <Label>İlçe *</Label>
                                            <Input
                                                type="select"
                                                value={formik.values.customer_district}
                                                onChange={e => formik.setFieldValue('customer_district', e.target.value)}
                                                disabled={!selectedProvince}
                                                invalid={formik.touched.customer_district && !!formik.errors.customer_district}
                                            >
                                                <option value="">İlçe seçiniz</option>
                                                {districtOptions.map(dist => (
                                                    <option key={dist} value={dist}>
                                                        {dist}
                                                    </option>
                                                ))}
                                            </Input>
                                            {formik.touched.customer_district && formik.errors.customer_district && (
                                                <FormFeedback>{formik.errors.customer_district}</FormFeedback>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <FormGroup className="mb-3">
                                    <Label>Detaylı Adres *</Label>
                                    <Input
                                        type="textarea"
                                        rows="3"
                                        placeholder="Mahalle, sokak, bina no, daire no..."
                                        value={formik.values.customer_address}
                                        onChange={e => formik.setFieldValue('customer_address', e.target.value)}
                                        invalid={formik.touched.customer_address && !!formik.errors.customer_address}
                                    />
                                    {formik.touched.customer_address && formik.errors.customer_address && (
                                        <FormFeedback>{formik.errors.customer_address}</FormFeedback>
                                    )}
                                </FormGroup>
                            </>
                        )}
                    </>
                )}
            </CardBody>
        </Card>
    );
};

export default CustomerForm;